import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmojiPeopleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"emoji_people"}/>
}
